import gql from 'graphql-tag';
import { TAG_FRAGMENT } from '../../fragments/tag.fragment';

export const QUERY_ACADEMIC_WORKS_TABLE = gql`
  query academicWorksTable {
    academicWorks: summaries {
      id
      authors {
        name
      }
      content {
        title
        language
      }
      tags {
        ...TagData
      }
    }
  }
  ${TAG_FRAGMENT}
`;
